import { createContext } from 'react'

export const WindowContext = createContext<Window>(window)
export const AppRootContext = createContext<HTMLElement>(null)
